"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
// eslint-disable-next-line complexity
function compileButtonStyle(branding) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { button = {} } = branding;
    const result = (0, utils_1.process)({
        'button-action-bg': button === null || button === void 0 ? void 0 : button.bgColor,
        'button-action-border-radius': button === null || button === void 0 ? void 0 : button.borderRadius,
        'button-disabled-bg': (_a = button === null || button === void 0 ? void 0 : button.disabled) === null || _a === void 0 ? void 0 : _a.bgColor,
        'button-disabled-text-color': (_b = button === null || button === void 0 ? void 0 : button.disabled) === null || _b === void 0 ? void 0 : _b.color,
        'button-disabled-text-opacity': (_c = button === null || button === void 0 ? void 0 : button.disabled) === null || _c === void 0 ? void 0 : _c.textOpacity,
        'button-focus-visible-border-color': (_e = (_d = button === null || button === void 0 ? void 0 : button.focusVisible) === null || _d === void 0 ? void 0 : _d.border) === null || _e === void 0 ? void 0 : _e.color,
        'button-r-font-size': button === null || button === void 0 ? void 0 : button.fontSize,
        'button-r-height': button === null || button === void 0 ? void 0 : button.height,
        'button-action-hover-bg': (_f = button === null || button === void 0 ? void 0 : button.hover) === null || _f === void 0 ? void 0 : _f.bgColor,
        'button-action-min-width': button === null || button === void 0 ? void 0 : button.minWidth,
        'button-action-margin-top': (_g = button === null || button === void 0 ? void 0 : button.margin) === null || _g === void 0 ? void 0 : _g.top,
        'button-action-margin-between': (_h = button === null || button === void 0 ? void 0 : button.margin) === null || _h === void 0 ? void 0 : _h.between
    });
    if (button === null || button === void 0 ? void 0 : button.fontWeight) {
        return Object.assign(Object.assign({}, result), { '--button-font-weight': button.fontWeight, '--button-action-font-weight': button.fontWeight });
    }
    return result;
}
exports.default = compileButtonStyle;
